// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top-line {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\nh1 {\n  display: inline;\n}\n", ""]);
// Exports
module.exports = exports;
